import { useEffect } from 'react';
import { setToken } from 'src/utils/localStorage';

/**
 * Legge `token` o `jwt` dal querystring, lo persiste in localStorage
 * e pulisce l'URL rimuovendo i parametri sensibili.
 */
export const usePersistJwtFromQuery = () => {
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const jwt = url.searchParams.get('token') || url.searchParams.get('jwt');
      if (jwt && jwt.trim().length > 0) {
        setToken(jwt);
        url.searchParams.delete('token');
        url.searchParams.delete('jwt');
        window.history.replaceState({}, document.title, url.toString());
      }
    } catch {
      // Non bloccare l'app se l'URL non è valido
    }
  }, []);
};
